import { DialogContent } from './ui/DialogContent';
import { useRef } from 'react';
import { Button, CircularProgress, DialogContentText } from '@mui/material';
import { ResponsiveDialog } from './ui/ResponsiveDialog';
import { DialogHeader } from './ui/DialogHeader';
import { DialogActions } from './ui/DialogActions';
export default function DeleteConfirmModal({
  open,
  onClose,
  handleConfirmDelete,
  deleting = false,
}: {
  open: boolean;
  onClose: () => void;
  handleConfirmDelete: () => void;
  deleting?: boolean;
}) {
  const cancelRef = useRef<HTMLButtonElement>(null);
  return (
    <ResponsiveDialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-item-title"
      aria-describedby="delete-item-description"
      TransitionProps={{ onEntered: () => cancelRef.current?.focus() }}
    >
      <DialogHeader
        id="delete-item-title"
        title="Move item to Bin?"
        onClose={onClose}
      />
      <DialogContent>
        <DialogContentText id="delete-item-description">
          You can restore it later from Bin in the application menu.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button ref={cancelRef} onClick={onClose} disabled={deleting}>
          Cancel
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={handleConfirmDelete}
          disabled={deleting}
          startIcon={
            deleting ? (
              <CircularProgress size={16} color="inherit" />
            ) : undefined
          }
        >
          {deleting ? 'Moving…' : 'Move to Bin'}
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  );
}
